import * as type from '../mutation-types'

const state = {
  demoList: {}
}

const getters = {
  demoList: state => state.demoList
}

const actions = {
  setDemoList ({commit}, list) {
    commit(type.DEMO_MUTATION, list)
  }
}

const mutations = {
  [type.DEMO_MUTATION] (state, list) {
    state['demoList'] = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/demoVuex.js